import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function POPaymentsPage() {
  return (
    <SectionLayout title="PO Payments">
      {/* PO payments content will go here */}
    </SectionLayout>
  );
} 